// +++++++++++++++++++++
// AA: Helper Functions & variables
// +++++++++++++++++++++

var isMobile = function () {
  return window.screen.availWidth <= 960
}

var formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '')
  }
  var value = ''
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  var formatString = format || this.money_format

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

var scrollY

var addNoScroll = function () {
  // only add to no scroll if the body doesn't already have it!
  if (!$(document.body).hasClass('no-scroll')) {
    scrollY = window.pageYOffset

    $(document.body).css({ top: -scrollY + 'px' })
    $('html').addClass('no-scroll')
    $(document.body).addClass('no-scroll')
  }
}

var removeNoScroll = function () {
  $(document.body).removeClass('no-scroll')
  $(document.body).css({ top: '' })

  window.scrollTo(0, scrollY || 0)
  $('html').removeClass('no-scroll')
}

var toggleNoScroll = function () {
  if (!$(document.body).hasClass('no-scroll')) {
    removeNoScroll()
  } else {
    addNoScroll()
  }
}

// +++++++++++++++++++++
// AA: Navigation Module
// +++++++++++++++++++++
var navigation = (function () {
  var settings = {
    clickLinks: '.js-mega-link',
    megaMenu: '.js-mega-menu',
    megaContainer: '.js-mega-container',
    overlay: '.js-overlay',
    activeClass: 'active',
    hamburgerClass: 'js-hamburger',
    logo: '.js-logo',
    secondaryLogo: '.js-secondary-logo',
    searchToggle: '.js-toggle-search',
    searchForm: '.js-search-form',
    stickyNav: '.js-sticky-nav',
    closeSubmenu: '.js-close-submenu',
  }

  var init = function () {
    initializeEventListeners()
    initSearchForm()
  }

  var initializeEventListeners = function () {
    // event listeners here!
    $(settings.clickLinks).on('click', openMegaMenu)
    $(settings.overlay).on('click', closeMegaMenu)
    $(window).on('keydown', listenForEscape)
    $(settings.closeSubmenu).on('click', closeSubMenu)
    $(settings.searchToggle).on('click', toggleSearchForm)
    $(window).on('scroll', $.throttle(250, handleNavigationScroll))
  }

  var trapUserFocus = function () {
    $(window).on('keydown', cycleFocusableMenuElements)
  }

  var cycleFocusableMenuElements = function (e) {
    var firstFocusableElement = document.querySelector('.js-hamburger')
    var lastFocusableElement = document.querySelector('.js-mega-menu-login-button')

    if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault()
      lastFocusableElement.focus()
    } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault()
      firstFocusableElement.focus()
    }
  }

  var listenForEscape = function (e) {
    if (e.keyCode === 27 && $(settings.megaMenu).hasClass('active')) {
      closeMegaMenu(e)
    }
  }

  var openMegaMenu = function (e) {
    // Click on Shop -> open mega menu for Shop
    var $this = $(this)
    var menuReference = $this.data('link')
    var $menus = $(settings.megaMenu)

    var $activeMenu = $(settings.megaMenu + '[data-link="' + menuReference + '"]')

    var hasOpenMenu = hasOpenMenus()
    var mobileScreen = isMobile()

    if ($activeMenu.length) {
      e.preventDefault()
      $this.toggleClass(settings.activeClass)

      if (mobileScreen && hasOpenMenu && $this.hasClass(settings.hamburgerClass)) {
        // mobile click on hamburger when the menu is already open
        closeMegaMenu()
        $activeMenu.attr('tabindex', '-1')
        $this.attr('aria-expanded', 'false')
        $(settings.megaMenu).attr('aria-hidden', 'true')
      } else {
        if (mobileScreen) {
          addNoScroll()
          $activeMenu.addClass(settings.activeClass).show()
          $(settings.overlay).addClass(settings.activeClass)
          $(settings.stickyNav).css({ position: 'fixed' })
          $this.attr('aria-expanded', 'true')
          $activeMenu.attr('aria-hidden', 'false')

          trapUserFocus()
          if ($this.hasClass('js-mega-submenu-link')) {
          } else {
          }
        } else {
          if (hasOpenMenu) {
            // open the mega menu and close any other open menus
            if (mobileScreen) {
              // close the mobile menu
              removeNoScroll()
              $activeMenu.removeClass(settings.activeClass)
              $(settings.overlay).removeClass(settings.activeClass)
            } else {
              $menus.not($activeMenu).hide().removeClass(settings.activeClass)
              $(settings.clickLinks).not($this).removeClass(settings.activeClass)

              if ($activeMenu.hasClass(settings.activeClass)) {
                // clicked the link that is currently open
                removeNoScroll()
                $(settings.overlay).removeClass(settings.activeClass)
                $activeMenu.slideUp(400).removeClass(settings.activeClass)
              } else {
                // clicked a different mega menu link
                $activeMenu.show().addClass(settings.activeClass)
                $(settings.overlay).addClass(settings.activeClass)
              }
            }
          } else {
            // no menus are open -> open & animate the active menu.
            addNoScroll()
            $activeMenu.slideDown(400).addClass(settings.activeClass)
            $(settings.overlay).addClass(settings.activeClass)
          }
        }
      }
    }
  }

  var closeMegaMenu = function (e) {
    removeNoScroll()
    if (isMobile()) {
      $(settings.stickyNav).css({ position: 'sticky' })
      $(settings.megaMenu).removeClass(settings.activeClass).hide()
    } else {
      $(settings.megaMenu).slideUp(400).removeClass(settings.activeClass)
    }
    $(settings.overlay).removeClass(settings.activeClass)
    $(settings.clickLinks).removeClass(settings.activeClass)
  }

  var closeSubMenu = function (e) {
    e.preventDefault()

    var $this = $(this)
    var menuReference = $this.data('link')
    var $activeMenu = $(settings.megaMenu + '[data-link="' + menuReference + '"]')
    $activeMenu.removeClass(settings.activeClass)
    $this.attr('aria-expanded', 'false')
    $activeMenu.css('display', 'none')
    $activeMenu.attr('aria-hidden', 'true')
  }

  var hasOpenMenus = function () {
    return $(settings.megaMenu).hasClass(settings.activeClass)
  }

  var handleNavigationScroll = function (e) {
    // hidden for holiday sale 2023
    /* if (window.scrollY > 300) {
      $(settings.secondaryLogo).removeClass('hide');
      $(settings.logo).addClass('hide');
    } else {
      $(settings.logo).removeClass('hide');
      $(settings.secondaryLogo).addClass('hide');
    }*/
    // if (window.scrollY > 40) {
    //   $(settings.stickyNav).css({ position: 'fixed' });
    // } else {
    //   $(settings.stickyNav).css({ position: 'sticky' });
    // }
  }

  var initSearchForm = function () {
    $(settings.searchForm).hide()
  }

  var toggleSearchForm = function (e) {
    e.preventDefault()

    $(settings.searchForm).addClass('active')
    $(settings.searchForm).slideToggle(200)

    $(settings.searchForm).find('input').focus()
  }

  return {
    init: init,
  }
})()

// +++++++++++++++++++++
// TS: Homepage Video Sync
// +++++++++++++++++++++

const homepageVideoSync = (function () {
  const settings = {
    mainContent: '#main',
    video: '.js-video-hero',
  }

  const getTopOffset = function () {
    return $(settings.mainContent).position().top
  }

  const syncVideoHeight = function ($video) {
    let topOffset = getTopOffset()
    let maxHeight = `calc(100vh - ${topOffset}px)`

    $video.css('--max-height', maxHeight)
  }

  const init = function () {
    let $video = $(settings.video)
    if ($video.length) {
      syncVideoHeight($video)
    }
  }

  return {
    init: init,
  }
})()

// +++++++++++++++++++++
// SS: Slick Sliders
// +++++++++++++++++++++
var slickSliders = (function () {
  var settings = {
    collectionMobileSlider: '.js-collection-mobile-slider',
    fabricCardSlider: '.js-fabric-cards',
    lifestyleSlider: '.js-lifestyle-images',
  }

  var init = function () {
    // init sliders here!
    if (window.screen.availWidth < 1024) {
      $(settings.fabricCardSlider).slick(fabricSliderSettings)
    }

    $(settings.lifestyleSlider).each((index, slider) => {
      if ($(slider).hasClass('lifestyle-images--halves')) {
        $(slider).slick(lifestyleSliderSettings2)
      } else {
        $(slider).slick(lifestyleSliderSettings)
      }
    })
    

    if (window.screen.availWidth < 501) {
      $(settings.collectionMobileSlider).slick(collectionSliderSettings)
    }

    // $(window).on('resize', unslickSliders);
  }

  // var unslickSliders = function (e) {
  //   if (window.screen.availWidth > 1023) {
  //     // desktop
  //     // $(settings.fabricCardSlider).slick("unslick");
  //     $(settings.lifestyleSlider).slick('unslick')
  //   }

  //   if (window.screen.availWidth > 501) {
  //     $(settings.collectionMobileSlider).slick('unslick')
  //   } else {
  //     $(settings.collectionMobileSlider).not('.slick-initialized').slick(collectionSliderSettings)
  //   }
  // }

  var generalSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 100,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick',
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
    ],
  }

  var fabricSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: false,
    centerMode: true,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 100,
        },
      },
    ],
  }

  var lifestyleSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    // autoplay: true,
    // autoplaySpeed: 0,
    // speed: 4000,
    // cssEase: 'linear',
    arrows: false,
    speed: 100,
    dots: true,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 1023,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 300,
        },
      },
    ],
  }

  var lifestyleSliderSettings2 = {
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: false,
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    speed: 100,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 1023,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          speed: 300,
        },
      },
    ],
  }

  var collectionSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 500,
        settings: {
          speed: 100,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return {
    init: init,
  }
})()

// +++++++++++++++++++++
// SS: Accessibility
// +++++++++++++++++++++
var accessibility = (function () {
  var settings = {
    focusObject: '.focus-accessible',
  }

  var init = function () {
    initializeEventListeners()
  }

  var initializeEventListeners = function () {
    //Accessibility for opaque buttons
    $(settings.focusObject).on('focus', focusOn)
    $(settings.focusObject).on('blur', focusOn)
  }

  var focusOn = function () {
    $(this).parent('.focus-parent').addClass('focus-visible')
  }

  return {
    init: init,
  }
})()

// +++++++++++++++++++++
// Accordion + FAQ
// +++++++++++++++++++++
var accordion = (function () {
  var settings = {
    title: '.js-accordion-title',
    content: '.js-accordion-content',
    accordionContainer: '.js-accordion',
    accordionGroup: '.js-accordion-group',
    mainSection: '.js-main-section',
    activeClass: 'active',
    filter: '#filter',
  }

  var init = function () {
    if ($(settings.title).length === 0) return

    initializeEventListeners()
  }

  var initializeEventListeners = function () {
    $(settings.title).on('click', togglePanel)
    $(settings.filter).on('keyup', $.throttle(200, filterFAQs))
  }

  var filterFAQs = function () {
    var filter = $(this).val()

    $(settings.mainSection).each(function (index, section) {
      // Loop through the sections
      var count = 0
      $(section)
        .find(settings.accordionGroup)
        .each(function (index, group) {
          // Loop through the FAQS
          var val = '^(?=.*\\b' + $.trim(filter).split(/\s+/).join('\\b)(?=.*\\b') + ').*$',
            reg = RegExp(val, 'i'),
            text = $(this).text().replace(/\s+/g, ' '),
            kps = $(this).data('keyphrase')

          // If the list item does not contain the text phrase fade it out
          if (!reg.test(text) && !reg.test(kps)) {
            $(this).hide()
            // Show the list item if the phrase matches and increase the count by 1
          } else {
            $(this).show()
            count++
          }
        })

      if (count > 0) {
        $(section).show()
      } else {
        $(section).hide()
      }
    })
  }

  var togglePanel = function () {
    var $container = $(this).parents(settings.accordionContainer)
    var $currentTitle = $(this).find('a')
    var $currentContent = $(this).next(settings.content)

    if ($currentTitle.attr('aria-expanded') == 'false') {
      var $activeTitle = $container.find('[aria-expanded=true]')
      var $activeContent = $container.find('[aria-hidden=false]')

      // closes any active titles
      $activeTitle.attr('aria-expanded', false).removeClass(settings.activeClass)
      // closes any active content
      $activeContent.slideUp(200).attr('aria-hidden', 'true')

      // opens new content
      $currentTitle.attr('aria-expanded', true).addClass('active')
      $currentContent.slideDown(200).attr('aria-hidden', 'false')
      const $contentSlider = $currentContent.find('[data-slick]')

      if ($contentSlider.length) {
        const slickEvent = new CustomEvent('slick:reinit')
        $contentSlider[0].dispatchEvent(slickEvent)
      }

      var id = $(this).parent().attr('id')

      if (id) {
        // @arren
        // location.hash = "#" + id;
        // history.pushState(null, null, '#' + id);
      }
    } else {
      // close the clicked content
      $currentTitle.attr('aria-expanded', false).removeClass('active')
      $currentContent.slideUp(200).attr('aria-hidden', 'true')
    }
    // No Boing Boing
    return false
  }

  return {
    init: init,
  }
})()

// custom select for product options
var customSelect = (function () {
  var settings = {
    customSelect: '.js-custom-select',
    selectTrigger: '.js-custom-trigger',
    selectOption: '.js-custom-option',
    selectButton: '.js-select-button',
    triggerSelect: '.js-trigger-option',
    hiddenSelect: '.js-hidden-select',
    sidebar: '.js-custom-select-sidebar',
    popoverToggle: '.js-in-production-toggle',
    productionPopover: '.js-in-production-popover',
    overlay: '.js-overlay',
    closeButton: '.js-close-custom-select',
    variantLabel: '.variant-title',
  }

  var init = function () {
    if (!$(settings.customSelect).length) return

    initializeEventListeners()

    linkActiveOptions()
  }

  var initializeEventListeners = function () {
    $(settings.selectTrigger).on('click', toggleSidebar)
    $(settings.overlay).on('click', closeSidebar)
    $(settings.selectOption).on('click', setActiveOption)
    $(settings.selectButton).on('click', selectActiveOption)
    $(settings.popoverToggle).on('click', toggleInProdPopover)
    $(settings.closeButton).on('click', closeSidebar)
    $(settings.variantLabel).on('click', preventDefaultLabelClickBehavior)
    $(window).on('keydown', closeSidebarOnEscapePress)
  }

  var preventDefaultLabelClickBehavior = function (e) {
    e.preventDefault()
  }

  var linkActiveOptions = function () {
    /* if ($(settings.selectTrigger).length > 1) {
      // Need to be able to restrict options in case they don't all match up.

      var $firstTrigger = $(settings.selectTrigger).eq(0);
      var value = $firstTrigger.find('.active').data('value');
      var $secondSidebar = $(settings.sidebar).eq(1);

      var optionTitles = [];
      $(settings.hiddenSelect).find('option').each(function(index, option){
        // find any options that match the first selectTrigger
        var title = $(option).data('title');

        if (title.includes(value)) {
          optionTitles.push(title);
        }
      })

      var $sidebarOptions = $secondSidebar.find(settings.selectOption);

      $sidebarOptions.hide();

      optionTitles.forEach(function(optionTitle){
        $sidebarOptions.each(function(index, option){
          var dataValue = $(option).data('value');

          if (optionTitle.includes(dataValue)) {
            $(option).show();
          }
        })
      })

      if ($sidebarOptions.closest('.active').is(':hidden')){
        $sidebarOptions.closest(".js-custom-option:visible").eq(0).click();
      }
    }*/
  }

  var toggleSidebar = function (e) {
    var trigger = $(this).data('trigger')

    var $activeSidebar = $(settings.sidebar + '[data-trigger="' + trigger + '"]')

    $activeSidebar.toggleClass('open')

    if ($activeSidebar.hasClass('open')) {
      // $activeSidebar.find('.js-custom-option').first().focus();
      $(settings.sidebar).css('visibility', 'visible')
      setTimeout(() => {
        limitUserFocus('.js-custom-select-sidebar', '.js-close-custom-select', '.js-select-button')
      }, 100)
    }
    $(settings.sidebar).not($activeSidebar).removeClass('open')

    var overlay = $(settings.overlay)

    overlay.css({
      top: 0,
    })
    overlay.toggleClass(['active', 'cart-overlay', 'sidebar-overlay'])

    if ($(settings.sidebar).hasClass('open')) {
      addNoScroll()
    } else {
      removeNoScroll()
    }
  }

  var closeSidebar = function (e) {
    removeNoScroll()
    $(settings.sidebar).removeClass('open')

    setTimeout(() => {
      $(settings.sidebar).css('visibility', 'hidden')
    }, 500)

    var overlay = $(settings.overlay)

    overlay.css({
      top: 0,
    })

    overlay.removeClass(['active', 'cart-overlay', 'sidebar-overlay'])
    $(settings.selectTrigger).focus()
  }

  var closeSidebarOnEscapePress = function (e) {
    if ($('.js-custom-select-sidebar').hasClass('open') && e.key === 'Escape') {
      closeSidebar()
    }
  }

  var setActiveOption = function (e) {
    // limit the scope to specific sidebar / toggle combo
    var $this = $(this)
    var $sidebar = $this.parents(settings.sidebar)
    var $otherOptions = $sidebar.find(settings.selectOption).not($this)
    var trigger = $sidebar.data('trigger')

    $this.addClass('active')
    $otherOptions.removeClass('active')

    var $activeSelect = $(settings.selectOption + '.active')
    var $selectContainer = $(settings.customSelect + '[data-trigger="' + trigger + '"]')
    var id = $selectContainer.data('for')

    var value = $(this).data('value')

    var values = []
    var titleValue

    $activeSelect.each(function (index, select) {
      values.push($(select).data('value'))
    })

    titleValue = values.join(' / ')

    var hiddenSelect = $('#' + id)

    var $triggerSelect = $selectContainer
      .find(settings.selectTrigger)
      .find(settings.triggerSelect + '[data-value="' + value + '"]')

    $triggerSelect.addClass('active')
    $selectContainer.find(settings.triggerSelect).not($triggerSelect).removeClass('active')

    if (values.length > 1) {
      var activeOption
      hiddenSelect.find('option').each(function (index, option) {
        if ($(option).data('title') === titleValue) {
          activeOption = $(option)
        }
      })
      if (activeOption) {
        hiddenSelect.val(activeOption.val()).change()
      }
    } else {
      hiddenSelect.val(value).change()
    }

    linkActiveOptions()
  }

  var selectActiveOption = function () {
    // var $activeSelect = $(settings.selectOption + ".active");
    // var $selectContainer = $(settings.customSelect);
    // var id = $selectContainer.data('for');
    // var value = $activeSelect.data('value');
    // var hiddenSelect = $("#" + id);
    //
    // var $triggerSelect = $(settings.selectTrigger).find(settings.triggerSelect + '[data-value="' + value + '"]');
    //
    // $triggerSelect.addClass('active');
    // $(settings.triggerSelect).not($triggerSelect).removeClass('active');
    //
    // hiddenSelect.val(value).change();
    toggleSidebar()
  }

  var toggleInProdPopover = function () {
    $(settings.productionPopover).toggleClass('active')
  }

  return { init: init }
})()

// custom select for custom fields / add on things
var CFCustomSelect = (function () {
  var settings = {
    customSelect: '.js-cf-custom-select',
    selectTrigger: '.js-cf-custom-trigger',
    selectOption: '.js-cf-custom-option',
    selectButton: '.js-cf-select-button',
    triggerSelect: '.js-cf-trigger-option',
    hiddenSelect: '.js-cf-hidden-select',
    sidebar: '.js-cf-custom-select-sidebar',
    popoverToggle: '.js-cf-in-production-toggle',
    productionPopover: '.js-cf-in-production-popover',
    overlay: '.js-overlay',
    closeButton: '.js-cf-close-custom-select',
    variantLabel: '.cf-variant-title',
  }

  var init = function () {
    if (!$(settings.customSelect).length) return

    initializeEventListeners()

    $(settings.selectOption + '.default').click()
  }

  var initializeEventListeners = function () {
    $(settings.selectTrigger).on('click', toggleSidebar)
    $(settings.overlay).on('click', closeSidebar)
    $(settings.selectOption).on('click', setActiveOption)
    $(settings.selectButton).on('click', selectActiveOption)
    $(settings.popoverToggle).on('click', toggleInProdPopover)
    $(settings.closeButton).on('click', closeSidebar)
    $(settings.variantLabel).on('click', preventDefaultLabelClickBehavior)
    $(window).on('keydown', closeSidebarOnEscapePress)
  }

  var preventDefaultLabelClickBehavior = function (e) {
    e.preventDefault()
  }

  var toggleSidebar = function (e) {
    var trigger = $(this).data('trigger')
    var $activeSidebar = $(settings.sidebar + '[data-trigger="' + trigger + '"]')

    $activeSidebar.toggleClass('open')

    if ($activeSidebar.hasClass('open')) {
      // $activeSidebar.find('.js-custom-option').first().focus();
      $activeSidebar.css('visibility', 'visible')
      setTimeout(() => {
        limitUserFocus('.js-cf-custom-select-sidebar', '.js-cf-close-custom-select', '.js-cf-select-button')
      }, 100)
    }
    $(settings.sidebar).not($activeSidebar).removeClass('open')

    var overlay = $(settings.overlay)

    overlay.css({
      top: 0,
    })

    overlay.toggleClass(['active', 'cart-overlay', 'sidebar-overlay'])

    if ($(settings.sidebar).hasClass('open')) {
      addNoScroll()
    } else {
      removeNoScroll()
    }
  }

  var closeSidebar = function (e) {
    removeNoScroll()
    $(settings.sidebar).removeClass('open')

    setTimeout(() => {
      $(settings.sidebar).css('visibility', 'hidden')
    }, 500)

    var overlay = $(settings.overlay)

    overlay.css({
      top: 0,
    })

    overlay.removeClass(['active', 'cart-overlay', 'sidebar-overlay'])
    $(settings.selectTrigger).focus()
  }

  var closeSidebarOnEscapePress = function (e) {
    if ($('.js-cf-custom-select-sidebar').hasClass('open') && e.key === 'Escape') {
      closeSidebar()
    }
  }

  var setActiveOption = function (e, init) {
    // limit the scope to specific sidebar / toggle combo
    var $this = $(this)
    var $sidebar = $this.parents(settings.sidebar)
    var $otherOptions = $sidebar.find(settings.selectOption).not($this)
    var trigger = $sidebar.data('trigger')

    $this.addClass('active')
    $otherOptions.removeClass('active')

    var $selectContainer = $(settings.customSelect + '[data-trigger="' + trigger + '"]')
    var id = $selectContainer.data('for')

    var value = $(this).data('value')

    var hiddenSelect = $('#' + id)

    var $triggerSelect = $selectContainer
      .find(settings.selectTrigger)
      .find(settings.triggerSelect + '[data-value="' + value + '"]')
    $triggerSelect.addClass('active')
    $selectContainer.find(settings.triggerSelect).not($triggerSelect).removeClass('active')

    hiddenSelect.val(value).change()
    if ($(settings.sidebar).hasClass('open')) {
      toggleSidebar()
    }
  }

  var selectActiveOption = function () {
    toggleSidebar()
  }

  var toggleInProdPopover = function () {
    $(settings.productionPopover).toggleClass('active')
  }

  return { init: init }
})()

// AA Animation Module
// Use for adding animations on page scroll / element in view

var animations = (function () {
  var classes = {
    willAnimate: '.will-animate',
    isAnimating: 'animate',
  }

  var observeAnimations = function (entries, observer) {
    entries.forEach((entry) => {
      let $target = $(entry.target)
      if (!$target.hasClass(classes.isAnimating) && entry.isIntersecting) {
        let delay = $target.data('delay')
        if (delay) {
          setTimeout(function () {
            $target.addClass(classes.isAnimating)
          }, parseInt(delay))
        } else {
          $target.addClass(classes.isAnimating)
        }
      }
    })
  }

  var initializeAnimationsObserver = function () {
    if (typeof IntersectionObserver === 'function') {
      let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      }

      let observer = new IntersectionObserver(observeAnimations, options)

      let $targets = $(classes.willAnimate)

      $targets.each(function (index, target) {
        observer.observe(target)
      })
    } else {
      let $targets = $(classes.willAnimate).addClass(classes.isAnimating)
    }
  }

  var init = function () {
    if ($(classes.willAnimate).length === 0) {
      return
    }

    initializeAnimationsObserver()
  }

  return {
    init: init,
  }
})()

// +++++++++++++++++++++
// Account
// +++++++++++++++++++++
var account = (function () {
  var settings = {
    recoverPasswordForm: '#RecoverPasswordForm',
    customerLoginForm: '#CustomerLoginForm',
    recoverPasswordLink: '.js-recover-password',
    container: '#account-page',
    accountAddresses: '.address-country-option',
    newAddressToggle: '.address-new-toggle',
    newAddressForm: '#AddressNewForm',
    editAddressToggle: '.address-edit-toggle',
    recoveryMessage: '.js-recover-message',
  }

  var init = function () {
    if ($(settings.container).length === 0) {
      return
    }

    initializeEventListeners()
    initializeAddressForms()

    if (location.hash === '#recover') {
      toggleRecoverForm()
    }

    initializeRecoveryMessage()
  }

  var handleRecoverPasswordSubmit = function (e) {
    var email = $(this).find('[name="email"]').val()

    sessionStorage.setItem('recoveryEmail', email)
  }

  var initializeRecoveryMessage = function () {
    var email = sessionStorage.getItem('recoveryEmail')
    if (location.pathname.includes('login') && email) {
      $(settings.recoveryMessage)
        .text('Password reset instructions have been sent to ' + email + '!')
        .removeClass('hide')
    }
  }

  var initializeEventListeners = function () {
    $(settings.recoverPasswordLink).on('click', toggleRecoverForm)
    $(settings.newAddressToggle).on('click', toggleNewAddressForm)
    $(settings.editAddressToggle).on('click', toggleEditAddressForm)
    $(settings.recoverPasswordForm).on('submit', handleRecoverPasswordSubmit)
  }

  var initliazeReChargeLinks = function (e) {
    var token = sessionStorage.getItem('rc_token')
    if (token) {
      $(settings.rechargeLinks).each(function (index, link) {
        var href = $(link).attr('href')
        href += href.includes('?') ? '&token=' + token : '?token=' + token

        $(link).attr('href', href)
      })
    }
  }

  var toggleRecoverForm = function (e) {
    if (e) {
      e.preventDefault()
    }

    $(settings.customerLoginForm).toggleClass('hide')
    $(settings.recoverPasswordForm).toggleClass('hide')
  }

  var toggleEditAddressForm = function (e) {
    e.preventDefault()

    var formId = $(this).attr('aria-owns')
    var $form = $('#' + formId)

    $form.toggleClass('hide')

    if ($form.hasClass('hide')) {
      $(this).text('edit')
    } else {
      $(this).text('cancel')
    }
  }

  var toggleNewAddressForm = function (e) {
    e.preventDefault()
    $(settings.newAddressForm).toggleClass('hide')

    if ($(settings.newAddressForm).hasClass('hide')) {
      $(this).text('new address')
    } else {
      $(this).text('cancel')
    }
  }

  var initializeAddressForms = function () {
    $(settings.accountAddresses).each(function (index, element) {
      var formId = $(this).data('form-id')
      var countrySelector = 'AddressCountry_' + formId
      var provinceSelector = 'AddressProvince_' + formId
      var containerSelector = 'AddressProvinceContainer_' + formId

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      })
    })
  }

  return {
    init: init,
  }
})()

var productFAQs = (function () {
  var settings = {
    faqHeading: '.js-tab-heading',
    faqContent: '.js-tab-content',
    sidebar: '.js-tab-sidebar',
    contentContainer: '.js-tab-content-container',
  }

  var init = function () {
    if ($(settings.faqHeading).length === 0) return

    var maxHeight = $(settings.sidebar).height()
    $(settings.contentContainer).css({ maxHeight: maxHeight })

    initializeEventListeners()
  }

  var initializeEventListeners = function () {
    $(settings.faqHeading).on('click', handleTabClick)
  }

  var handleTabClick = function (e) {
    e.preventDefault()

    var $this = $(this)
    var section = $this.data('section')
    var $content = $(settings.faqContent + '[data-section="' + section + '"]')

    if (isMobile()) {
      // toggle open / close on mobile only

      $this.toggleClass('active')
      $(settings.faqHeading).not($this).removeClass('active')

      $content.toggleClass('active')
      $(settings.faqContent).not($content).removeClass('active')
      // $this[0].scrollIntoView(true);
      const yOffset = -130
      const element = $this
      const y = element[0].getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    } else {
      $this.addClass('active')
      $(settings.faqHeading).not($this).removeClass('active')

      $content.addClass('active')
      $(settings.faqContent).not($content).removeClass('active')
    }
  }

  return {
    init: init,
  }
})()

var sidebarPage = (function () {
  var settings = {
    sidebarLink: '.js-sidebar-link',
    mainSection: '.js-main-section',
  }

  var linkWasClicked = false

  var init = function () {
    if ($(settings.sidebarLink).length === 0) return

    initializeEventListeners()
    loadSectionFromHash()
  }

  var initializeEventListeners = function () {
    $(settings.sidebarLink).on('click', handleTabClick)
    $(window).on('scroll', $.throttle(300, toggleActiveLink))
  }

  var toggleActiveLink = function (e) {
    var activeSection

    if (!linkWasClicked) {
      $(settings.mainSection).each(function (index, element) {
        var position = element.getBoundingClientRect()
        var height = element.offsetHeight
        var offset = window.screen.height

        // elementY < windowHeight - 150) && (elementY >= -10

        if (position.top > 100 - height && position.bottom - height < offset && !activeSection) {
          activeSection = element
        }
      })

      if (activeSection) {
        var section = $(activeSection).data('section')

        var $activeLink = $(settings.sidebarLink + '[data-section="' + section + '"]')

        $activeLink.addClass('active')
        $(settings.sidebarLink).not($activeLink).removeClass('active')
      }
    }
  }

  var handleTabClick = function (e) {
    // e.preventDefault();
    linkWasClicked = true

    setTimeout(function () {
      linkWasClicked = false
    }, 1000)

    var $this = $(this)
    var section = $this.data('section')

    var text = $this.text()

    $('.js-collection-nav-toggle').not('.collection-nav--close').text(text)

    $this.addClass('active')
    $(settings.sidebarLink).not($this).removeClass('active')

    var $content = $(settings.mainSection + '[data-section="' + section + '"]')
    $content.addClass('active')
    $(settings.mainSection).not($content).removeClass('active')
  }

  var loadSectionFromHash = function () {
    if (window.location.hash) {
      var element = document.getElementById(window.location.hash.replace('#', ''))

      if (element) {
        var $el = $(element)

        if ($el.hasClass('js-accordion-group')) {
          $el.find('.js-accordion-title a').click()
        }

        $('html, body').animate(
          {
            scrollTop: $(element).offset().top - 70,
          },
          0
        )

        // element.scrollIntoView(true);
      }
    }
  }

  return { init: init }
})()

// +++++++++++++++++++++
// Collection
// +++++++++++++++++++++

// try this first
// use section rendering on the collection section with the sort_by parameter included in the URL
// Afer the section re-renders, apply filters. Run the filter function on the new product cards

var collection = (function () {
  var settings = {
    container: '.js-collection',
    productCardImages: '.js-product-card-images',
    productCard: '.js-product-card',
    swatch: '.js-swatch',
    cardDetails: '.js-details',
    detailsSlider: '.js-details-slider',
    detailSlideLabel: '.js-details-slide',
    filterContainer: '.js-filter-container',
    filterParent: '.js-filter-parent',
    filterToggle: '.js-filter-toggle',
    filterToggleDesktop: '[data-hook="toggle-filter-desktop"]',
    // filterToggleDesktop: ".js-filter-toggle-desktop",
    filterInputs: '.js-collection-filter',
    resetFilters: '.js-reset-filters',
    cardSlider: '.js-product-card-slider',
    nextPages: '.js-next-pages',
    collectionGrid: '.js-collection-grid',
    overlay: '.js-overlay',
    activeClass: 'active',
    filterCount: '.js-filter-count',
    sortSelect: '[data-hook="sort"]',
  }

  var filters = {
    extColor: [],
    intColor: [],
    size: [],
    material: [],
    availability: [],
    laptopWidth: [],
    laptopDepth: [],
    laptopCompartment: [],
  }

  var anyFilterIsActive = false
  let colorLabels = []

  var init = function () {
    if (!$(settings.container).length) return

    resetFilters()
    initializeImageSliders()
    initializeCardSliders()

    initializeEventListeners()
    initializeNextPages()

    var minimalSession = sessionStorage.getItem('details')

    if (minimalSession === 'true') {
      $(settings.detailSlideLabel).click()
    }
  }

  var initializeEventListeners = function () {
    $(document).on('click', settings.swatch, handleSwatchClick)
    $(document).on('change', settings.detailsSlider, toggleDetails)
    $(document).on('click', settings.detailSlideLabel, changeDetailsSlider)
    $(document).on('click', settings.filterToggle, toggleFilters)
    $(document).on('click', settings.filterToggleDesktop, toggleFiltersDesktop)
    $(document).on('click', settings.overlay, closeFilters)
    $(document).on('click', settings.resetFilters, resetFilters)
    $(document).on('change', settings.filterInputs, handleFilterChange)
    $(document).on('change', settings.sortSelect, handleSortChange)
    setFilterMenuTopPositionOnPageLoad()
  }

  var setFilterMenuTopPositionOnPageLoad = function () {
    var height = $('.navigation').height()
    $(settings.filterContainer).css({ top: height })
  }

  var initializeNextPages = function () {
    var $nextPages = $(settings.nextPages)
    if ($nextPages.length) {
      let pageCount = $nextPages.data('pages')
      pageCount = parseInt(pageCount)
      for (var i = 2; i < pageCount + 1; i++) {
        let url = location.pathname + '?page=' + i + '&view=cards'
        $.ajax(url).then((html) => {
          $(settings.collectionGrid).append(html)
          animations.init()
        })
      }
    }
  }

  var handleSwatchClick = function (e) {
    // @arren here
    // don't go to product page
    e.preventDefault()
    e.stopPropagation()

    var $this = $(this)
    var sku = $this.data('sku')

    var $card = $this.parents(settings.productCard)
    var $imageSlider = $card.find(settings.productCardImages)

    // $imageSlider.slick('slickUnfilter');
    // $imageSlider.slick('slickFilter', function(index, slide){
    //   var $slide = $(slide);
    //   var colorData = $slide.data('colors');
    //   return colorData.includes(sku);
    // })

    var variantId = $this.find('img').data('variantId')

    var imageSource = $this.find('img').data('swap')
    $imageSlider.find('img').eq(0).attr('srcset', imageSource).attr('data-srcset', imageSource)

    // var $image = $imageSlider.find('img[data-variant-id="' + variantId + '"]').not('slick-cloned');
    // var index = $image.data('slickIndex');

    // update the product URL
    if (variantId) {
      var href = $card.find('.js-product-url').attr('href')

      if (href.match(/variant=\d*/)) {
        href = href.replace(/variant=\d*/, 'variant=' + variantId)
      } else {
        href = href.includes('?') ? href + '&variant=' + variantId : href + '?variant=' + variantId
      }

      $card.find('.js-product-url').attr('href', href)
      $card.find('.iWishAddColl').addClass('iwishcheck').removeClass('iWishAdded').attr('data-variant', variantId)
      iwishCheckColl()
    }

    // change product card image
    // if ($image.length && typeof index === "number") {
    //   $imageSlider.slick('slickGoTo', index, true);
    // }
  }

  var changeDetailsSlider = function () {
    var val = $(this).data('value')
    var $slider = $(settings.detailsSlider)

    if (val === 0 && $slider.is(':checked')) {
      $slider.click()
    } else if (val === 1 && !$slider.is(':checked')) {
      $slider.click()
    }
  }

  var toggleDetails = function (e) {
    if ($(this).is(':checked')) {
      $(settings.cardDetails).slideUp(300)
    } else {
      $(settings.cardDetails).slideDown(300)
    }

    sessionStorage.setItem('details', $(this).is(':checked'))
  }

  var toggleFilters = function () {
    $(settings.filterContainer).toggleClass('active')
    $(settings.filterParent).toggleClass('active')

    if ($(settings.filterContainer).hasClass('active')) {
      $(settings.filterContainer).css('visibility', 'visible')
      $(settings.overlay).addClass(settings.activeClass).addClass('filter-overlay')
      $(settings.filterContainer).find('js-filter-toggle').focus()
    } else {
      setTimeout(() => {
        $(settings.filterContainer).css('visibility', 'hidden')
        $(settings.overlay).removeClass(settings.activeClass).removeClass('filter-overlay')
      }, 300)
    }
  }

  var toggleFiltersDesktop = function () {
    $(settings.filterContainer).toggleClass('active')
    $(settings.filterParent).toggleClass('active')

    if ($(settings.filterContainer).hasClass('active')) {
      $(settings.filterContainer).show()
      $(settings.filterParent).show()
    } else {
      $(settings.filterContainer).hide()
      $(settings.filterParent).hide()
    }
  }

  var closeFilters = function () {
    if ($(settings.filterContainer).hasClass('active')) {
      $(settings.filterContainer).removeClass('active')
      $(settings.filterParent).removeClass('active')

      setTimeout(() => {
        $(settings.filterContainer).css('visibility', 'hidden')
        $(settings.overlay).removeClass(settings.activeClass).removeClass('filter-overlay')
      }, 300)
    }
  }

  let currentSort = 'manual'

  var handleSortChange = function (e) {
    const value = $(this).val()
    const sectionId = $(this).data('sectionid')

    currentSort = value
    // creating the URL to use for section render
    const url = `${window.location.pathname}?sort_by=${value}&sections=${sectionId}`

    // section rendering AJAX request
    $.ajax(url).then(function (response) {
      if (response && response[sectionId]) {
        // the current cards on the page
        const $originalGrid = $(settings.collectionGrid)

        // the replacement cards from the AJAX request
        const $content = $(response[sectionId]).find(settings.collectionGrid)

        $originalGrid.replaceWith($content)

        // get the new product cards and replace them in the collection
        animations.init()

        // re-filter the products
        filterProducts()
      }
    })
  }

  var handleFilterChange = function (e) {
    var $this = $(this)
    var title = $this.data('title')
    var name = $this.attr('name')
    var value = $this.val()
    let removing = false
    if (filters[name].includes(value)) {
      // remove the filter
      removing = true
      filters[name] = filters[name].filter(function (item) {
        return item !== value
      })
      if (name === 'extColor' || name === 'intColor') {
        colorLabels = colorLabels.filter((text) => text != title)
        let labelString = colorLabels.join(', ')
        $('.js-selected-color[data-color]').text(labelString)
        if (filters[name].length) {
          if (currentSort !== 'manual') {
            preselectSwatch(filters[name][0])
          }
        }
      }
    } else {
      if (name === 'extColor' || name === 'intColor') {
        if (value === 'all') {
          colorLabels = []
          $('.js-selected-color[data-color]').text('')
          filters[name] = []
        } else {
          colorLabels.push(title)
          let labelString = colorLabels.join(', ')
          $('.js-selected-color[data-color]').text(labelString)
          filters[name].push(value)
        }
      } else if (name === 'laptopWidth' || name === 'laptopDepth') {
        filters[name] = [parseFloat(value, 10)]
      } else if (name === 'laptopCompartment') {
        if (value === 'any-compartment') {
          filters[name] = []
        } else {
          filters[name] = [value]
        }
      } else {
        filters[name].push(value)
      }
    }

    filterProducts()

    if (!removing) {
      if (name === 'extColor' || name === 'intColor') {
        // select swatches with that color
        if (currentSort !== 'manual') {
          preselectSwatch(value)
        }
      }
    }

    if (isMobile() && location.pathname.includes('/collection')) {
      window.scrollTo(0, 120)
    }

    for (filter in filters) {
      if (filters[filter].length > 0) {
        $('.filter--toggle').addClass('active-filter')
        break
      } else {
        $('.filter--toggle').removeClass('active-filter')
      }
    }
    $(settings.sortSelect).val(currentSort).trigger('change')
  }

  var resetFilters = function (e) {
    // Reset checkbox filters
    $(settings.filterInputs + ':checked').click()
    // Reset color filters
    $('#color-all').click()
    $('#color-all-int').click()
    $('.js-selected-color[data-color]').text('')

    // Reset laptop storage filter
    $('#compartment-any').click()

    // Reset laptop width slider
    var $widthSlider = $('.js-laptop-width-slider')
    var defaultWidth = $widthSlider.data('default')
    $widthSlider.val(defaultWidth)
    $('.js-laptop-width-slider-value').html(`${defaultWidth}"`)

    // Reset laptop depth slider
    var $depthSlider = $('.js-laptop-depth-slider')
    var defaultDepth = $depthSlider.data('default')
    $('.js-laptop-depth-slider').val(defaultDepth)
    $('.js-laptop-depth-slider-value').html(`${defaultDepth}"`)

    // Reveal all product cards
    for (const filter in filters) {
      filters[filter] = []
    }
    filterProducts()
  }

  var filterProducts = function () {
    let filterCount = 0
    for (let f in filters) {
      if (filters[f].length) filterCount++
    }
    $(settings.filterCount).text(`(${filterCount})`)

    if (filterCount == 0) {
      // no active filters. Show all cards
      $(settings.productCard).show()
    } else {
      $(settings.productCard).each(function (index, card) {
        // if there are no filters active for each category, automatically passes
        var matchesSize = !filters.size.length
        var matchesMaterial = !filters.material.length
        var matchesAvail = !filters.availability.length
        var matchesIntColor = !filters.intColor.length
        var matchesExtColor = !filters.extColor.length
        var matchesLaptopWidth = !filters.laptopWidth.length
        var matchesLaptopDepth = !filters.laptopDepth.length
        var matchesLaptopCompartment = !filters.laptopCompartment.length
        var $this = $(this)
        var data = $this.data()
        var parsedSize = parseInt(data.size)
        var parsedLaptopWidth = parseFloat(data.laptopWidth)
        var parsedLaptopDepth = parseFloat(data.laptopDepth)

        var extColors = data.extColor.split('|')
        var intColors = data.intColor.split('|')
        // AVAIL
        if (filters.availability.includes(data.availability)) {
          matchesAvail = true
        }

        filters.material.forEach(function (material) {
          if (data.materials.includes(material)) {
            matchesMaterial = true
          }
        })

        // SIZE
        filters.size.forEach(function (size) {
          if (size === 'small' && parsedSize >= 2 && parsedSize < 10) {
            matchesSize = true
          } else if (size === 'medium' && parsedSize >= 10 && parsedSize < 20) {
            matchesSize = true
          } else if (size === 'large' && parsedSize >= 20) {
            matchesSize = true
          }
        })

        // LAPTOP WIDTH
        filters.laptopWidth.forEach(function (laptopWidth) {
          if (parsedLaptopWidth >= laptopWidth) {
            matchesLaptopWidth = true
          }
        })

        // LAPTOP DEPTH
        filters.laptopDepth.forEach(function (laptopDepth) {
          if (parsedLaptopDepth >= laptopDepth) {
            matchesLaptopDepth = true
          }
        })

        // LAPTOP COMPARTMENT
        filters.laptopCompartment.forEach(function (laptopCompartment) {
          if (laptopCompartment === data.laptopCompartment) {
            matchesLaptopCompartment = true
          }
        })

        // COLORS
        extColors.forEach(function (cardColor) {
          filters.extColor.forEach(function (color) {
            if (cardColor === color) {
              matchesExtColor = true
            }
          })
        })

        intColors.forEach(function (cardColor) {
          filters.intColor.forEach(function (color) {
            if (cardColor === color) {
              matchesIntColor = true
            }
          })
        })

        if (
          matchesSize &&
          matchesLaptopWidth &&
          matchesLaptopDepth &&
          matchesAvail &&
          matchesExtColor &&
          matchesIntColor &&
          matchesLaptopCompartment &&
          matchesMaterial
        ) {
          $this.show().addClass('active')
        } else {
          $this.hide().removeClass('active')
        }
      })

      if (filters.extColor.length) {
        // select swatches with that color
        const color = filters.extColor[filters.extColor.length - 1]
        preselectSwatch(color)
      } else if (filters.intColor.length) {
        const color = filters.intColor[filters.intColor.length - 1]
        preselectSwatch(color)
      }
    }

    // no results  w/ reset button
  }

  var findActiveSwatch = function (colorValue, card) {
    var activeSwatch = $(card).find(settings.swatch + '[data-color-primary="' + colorValue + '"]')
    if (!activeSwatch.length) {
      activeSwatch = $(card).find(settings.swatch + '[data-color-secondary="' + colorValue + '"]')
    }

    return activeSwatch
  }

  var preselectSwatch = function (colorValue) {
    const hiddenCards = $(settings.productCard).not('.active')
    let sortedCards = $(settings.productCard + '.active')
    if (currentSort === 'manual') {
      sortedCards = $(settings.productCard + '.active').sort(function (aCard, bCard) {
        let aSwatch = findActiveSwatch(colorValue, aCard)
        let bSwatch = findActiveSwatch(colorValue, bCard)

        let aIsOos = aSwatch.hasClass('out-of-stock')
        let bIsOos = bSwatch.hasClass('out-of-stock')

        // a is oos, b is in stock
        if (!aSwatch.length) {
          return 20
        } else if (aIsOos && !bIsOos) {
          return 10
        } else if (aIsOos && bIsOos) {
          // a is in stock
          return 0
        } else if (!aIsOos && bIsOos) {
          return -10
        }
      })
    }

    // $(settings.productCard + ".active").replaceWith(sortedCards);
    $(settings.collectionGrid).html(sortedCards)
    $(settings.collectionGrid).append(hiddenCards)

    // only iterate through the active cards, they've already been filtered!
    sortedCards.each(function (index, card) {
      let activeSwatch = findActiveSwatch(colorValue, card)
      activeSwatch.eq(0).trigger('click')
    })
  }

  var initializeCardSliders = function () {
    var $slider = $(settings.cardSlider)

    if ($slider.length) {
      $(window).on('resize', resizeCardHeights)
      $slider.on('init', resizeCardHeights)

      // $slider.on("init", function(e, el){
      // el.$slider.slick('slickGoTo', 0);
      // });

      $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        // centerMode: true, //request to turn off center mode
        // centerPadding: '5vw', // moved to mobile breakpoint
        arrows: true,
        dots: false,
        infinite: true,
        speed: 100,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '4vw',
            },
          },
        ],
      })

      $slider.slick('slickGoTo', 0)
    }
  }

  var resizeCardHeights = function (e) {
    var $sliders = $(settings.cardSlider)

    $sliders.each(function (index, slider) {
      var tallestCardHeight = 0
      var $currentSlider = $(slider)
      $currentSlider.find(settings.productCard).css({ minHeight: 0 })

      $currentSlider
        .find(settings.productCard)
        .not('.slick-cloned')
        .each(function (index, card) {
          var height = $(card).outerHeight() + 25

          if (height > tallestCardHeight) {
            tallestCardHeight = height
          }
        })

      if (window.screen.availWidth > 480) {
        $currentSlider.css({ maxHeight: tallestCardHeight + 60 })
        $currentSlider.find(settings.productCard).css({ minHeight: tallestCardHeight })
      } else {
        $currentSlider.css({ maxHeight: 'auto' })
        $currentSlider.find(settings.productCard).css({ minHeight: 0 })
      }
    })
  }

  var initializeImageSliders = function () {
    $(settings.productCardImages).each(function (index, el) {
      var $this = $(this)

      var config = {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        infinite: false,
        arrows: false,
        dots: false,
        speed: 100,
      }

      $this.slick(config)
    })
  }

  return {
    init: init,
  }
})()

var productRecommendations = (function () {
  var settings = {
    recommendationSection: '.js-product-recommendations',
    productCardImages: '.js-product-card-images',
    cardSlider: '.js-product-card-slider',
    productCard: '.js-product-card',
  }

  var init = function () {
    if (!$(settings.recommendationSection).length) return

    initializeRecommendations()
  }

  var initializeRecommendations = function () {
    const $productRecommendationsSection = $(settings.recommendationSection)
    const productId = $productRecommendationsSection.data('productId')
    const baseUrl = $productRecommendationsSection.data('baseUrl')
    const limit = $productRecommendationsSection.data('limit')
    let intent = $productRecommendationsSection.data('intent')

    // Build request URL
    let requestUrl =
      baseUrl + '?section_id=product-recommended&intent=' + intent + '&product_id=' + productId + '&limit=' + limit
    sendRecommendationRequest(requestUrl)
  }

  const sendRecommendationRequest = function (requestUrl) {
    // Create request and submit it using Ajax
    const $productRecommendationsSection = $(settings.recommendationSection)

    fetch(requestUrl)
      .then((response) => response.text())
      .then((text) => {
        var container = document.createElement('div')
        container.innerHTML = text
        var newHTML = container.querySelector(settings.recommendationSection).innerHTML

        if (!newHTML && requestUrl.includes('complementary')) {
          let url = requestUrl.replace('complementary', 'related')
          sendRecommendationRequest(url)
        } else {
          $productRecommendationsSection.html(newHTML)
          // initialize slick
          initializeImageSliders()
          initializeCardSliders()
        }
      })
  }

  var initializeImageSliders = function () {
    $(settings.recommendationSection)
      .find(settings.productCardImages)
      .each(function (index, el) {
        var $this = $(this)

        var config = {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          infinite: false,
          arrows: false,
          dots: false,
          speed: 100,
        }

        $this.slick(config)
      })
  }

  var initializeCardSliders = function () {
    var $slider = $(settings.recommendationSection).find(settings.cardSlider)

    if ($slider.length) {
      $(window).on('resize', resizeCardHeights)
      $slider.on('init', resizeCardHeights)

      $slider.not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        speed: 100,
        responsive: [
          {
            breakpoint: 1301,
            settings: {
              slidesToShow: 4,
              arrows: false,
              infinite: false,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      })
    }
  }

  var resizeCardHeights = function (e) {
    var $sliders = $(settings.cardSlider)

    $sliders.each(function (index, slider) {
      var tallestCardHeight = 0
      var $currentSlider = $(slider)
      $currentSlider.find(settings.productCard).css({ minHeight: 0 })

      $currentSlider
        .find(settings.productCard)
        .not('.slick-cloned')
        .each(function (index, card) {
          var height = $(card).outerHeight() + 25

          if (height > tallestCardHeight) {
            tallestCardHeight = height
          }
        })

      $currentSlider.css({ maxHeight: tallestCardHeight + 60 })
      $currentSlider.find(settings.productCard).css({ minHeight: tallestCardHeight })
    })
  }

  return { init: init }
})()

var videoSection = (function () {
  var settings = {
    videoTrigger: '.js-video-trigger',
    videoWrapper: '.js-video-wrapper',
    zoomImages: '.js-image-zoom',
  }

  var videoPlayer // for vimeo
  var player // for youtube
  var focusTriggerElement

  var iframe

  const delta = 6
  let startX
  let startY

  var init = function () {
    if ($(settings.videoWrapper).length === 0) return

    initializeEventListeners()
    slickImages()
  }

  var trackMouseMovement = function (e) {
    startX = e.pageX
    startY = e.pageY
  }

  var confirmClick = function (e) {
    e.preventDefault()
    const diffX = Math.abs(e.pageX - startX)
    const diffY = Math.abs(e.pageY - startY)

    if (e.keyCode === 13 || e.keyCode === 32) {
      toggleVideoWrapper(e, this)
    }

    if (diffX < delta && diffY < delta) {
      toggleVideoWrapper(e, this)
    }

    if ($(this).hasClass('video--close-button')) {
      returnFocusToParent()
    }
  }

  var initializeEventListeners = function () {
    $(settings.videoWrapper).on('click', function (e) {
      toggleVideoWrapper(e, this)
    })
    $(settings.videoTrigger).on('mousedown', trackMouseMovement)
    $(settings.videoTrigger).on('click', confirmClick)
    $(settings.videoTrigger).on('keydown', confirmClick)
    $(settings.videoWrapper).on('keydown', listenForEscape)
  }

  var listenForEscape = function (e) {
    if (e.keyCode === 27) {
      closeVideoWrapper(e)
    }
  }

  var closeVideoWrapper = function () {
    if (videoPlayer) {
      videoPlayer.pause().then(function () {
        var $section = $(settings.videoWrapper + '.active')
        $section.removeClass('active').hide()

        removeNoScroll()
      })
    } else if (player) {
      if (player) {
        player.pauseVideo()
      }
      var $section = $(settings.videoWrapper + '.active')
      $section.removeClass('active').hide()
      removeNoScroll()
    } else {
      var $section = $(settings.videoWrapper + '.active')
      $section.removeClass('active').hide()
      removeNoScroll()
    }

    $(settings.zoomImages).trigger('zoom.destroy')

    $(window).off('keydown', cycleFocusableVimeoElements)
    returnFocusToParent()
  }

  var cycleFocusableVimeoElements = function (e) {
    var modal = document.querySelector('.js-video-wrapper')
    var firstFocusableElement = modal.querySelector('.js-video-trigger.video--close-button')

    if (e.target === firstFocusableElement && e.key === 'Tab' && e.shiftKey) {
      e.preventDefault()
    } else if ($(e.target).parents('.js-video-wrapper').length === 0 && e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault()
      firstFocusableElement.focus()
    }
  }

  var trapUserFocus = function () {
    $(window).on('keydown', cycleFocusableVimeoElements)
  }

  var returnFocusToParent = function () {
    var $section = $(settings.videoWrapper + '.active')

    if (focusTriggerElement.length) {
      focusTriggerElement.focus()
    }

    if ($('.js-video-trigger.video--play-button').length) {
      $('.js-video-trigger.video--play-button').focus()
    }
  }

  var setFocusToDoc = function () {
    $(window).focus()
  }

  var onPlayerReady = function (event) {
    if (player) {
      player.playVideo()
    }
  }

  var toggleVideoWrapper = function (e, self) {
    e.preventDefault()
    e.stopPropagation()

    var $target = $(e.target)

    var $this = $(self)

    var target = $this.data('target')
    var imageId = $this.data('id')

    var $section = $(settings.videoWrapper + '[data-target="' + target + '"]')

    if (!$section.hasClass('active')) {
      focusTriggerElement = $this
      $section.addClass('active').show()
      $section.attr('aria-hidden', false)
      $(window).on('keydown', listenForEscape)
      iframe = $section.find('iframe')
      let $youtubeWrapper = $section.find('[data-youtube-link]')

      trapUserFocus(e)
      $section.find('.video--close-button').focus()

      var iframeSource = iframe.attr('src')
      let youtubeWrapperSrc = $youtubeWrapper.data('youtube-link')

      if (iframeSource && iframeSource.includes('vimeo')) {
        if (iframe.length) {
          videoPlayer = new Vimeo.Player(iframe)

          videoPlayer.on('play', setFocusToDoc)
          videoPlayer.play()

          console.log('got here')
        }
        addNoScroll()
      } else if (youtubeWrapperSrc) {
        let wrapperId = $youtubeWrapper.attr('id')
        let videoId = youtubeWrapperSrc.split('embed/')[1].split('?')[0]

        player = new YT.Player(wrapperId, {
          videoId: videoId,
          events: {
            onReady: onPlayerReady,
          },
        })
        addNoScroll()
      }
    } else {
      if ($target.hasClass('js-video-wrapper') || $this.hasClass('js-video-trigger')) {
        closeVideoWrapper()
        $section.attr('aria-hidden', true)
      }
    }

    $(settings.zoomImages).zoom({ magnify: 1.5 })

    if (imageId) {
      goToImage(imageId)
    }
    $('.js-image-lightbox').slick('setPosition')
  }

  var goToImage = function (imageId) {
    var $slider = $('.js-image-lightbox')

    if ($slider.length) {
      var image = $slider
        .find('img[data-id="' + imageId + '"]')
        .parents('.slick-slide')
        .not('.slick-cloned')
      let slides = $slider.find('.slick-slide').not('.slick-cloned')
      // let index = slides.index(image);
      let index = image.index() - 1

      $slider.slick('slickGoTo', index, true)
    }
  }

  var slickImages = function () {
    var settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 100,
    }

    $('.js-image-lightbox').slick(settings)
  }

  return {
    init: init,
  }
})()

var blogSection = (function () {
  var settings = {
    showMore: '.js-show-more',
    blogGrid: '.js-blog-articles',
  }

  var init = function () {
    if ($(settings.showMore).length === 0) return

    initializeEventListeners()
  }

  var initializeEventListeners = function () {
    $(settings.showMore).on('click', loadMoreArticles)
  }

  var loadMoreArticles = function (e) {
    e.preventDefault()
    var $this = $(this)
    var url = $this.attr('href')
    url = url.includes('?') ? url + '&view=ajax-grid' : url + '?view=ajax-grid'

    $.ajax(url).then(function (blogHTML) {
      var $html = $(blogHTML)
      var $cards = $html.filter('.article-card')
      var $link = $html.find('.js-show-more')
      var newUrl = $link.attr('href')

      $(settings.blogGrid).append($cards)
      if ($link.length) {
        $this.attr('href', newUrl)
      } else {
        $this.hide()
      }
    })
  }

  return {
    init: init,
  }
})()

var article = (function () {
  var settings = {
    articleBody: '.js-article-body',
  }

  var init = function () {
    if ($(settings.articleBody).length === 0) return

    normalizeArticleImages()
  }

  var normalizeArticleImages = function () {
    var $firstChild = $(settings.articleBody).children().eq(0)

    if ($firstChild) {
      var html = $firstChild.html()
      if (html.includes('<img')) {
        $firstChild.remove()
      } else if ($firstChild.closest('img').length) {
        $firstChild.remove()
      }
    }

    $(settings.articleBody)
      .find('img')
      .each(function (index, img) {
        var $img = $(img)
        $img.attr('width', '').attr('height', '')

        while ($img.parent(settings.articleBody).length !== 1) {
          $img.unwrap()
        }
      })
  }

  return {
    init: init,
  }
})()

var sectionNumbers = (function () {
  var settings = {
    numbers: '.js-section-number',
  }

  var init = function () {
    if ($(settings.numbers).length === 0) return

    $(settings.numbers).each(function (index, el) {
      var numberText = '0' + (index + 1) + '.'
      $(el).text(numberText)
    })
  }

  return { init: init }
})()

var mobileNavToggle = (function () {
  var settings = {
    mobileNavToggle: '.js-collection-nav-toggle',
    mobileCollectionNav: '.js-collection-nav',
    sidebarLink: '.js-sidebar-link',
  }

  var init = function () {
    if ($(settings.mobileNavToggle).length === 0) return

    $(document).on('click', settings.mobileNavToggle, toggleCollectionNav)
    $(document).on('click', settings.sidebarLink, closeCollectionNav)
  }

  var toggleCollectionNav = function (e) {
    e.preventDefault()
    $(settings.mobileCollectionNav).toggleClass('active')

    // if ($(settings.mobileCollectionNav).hasClass('active')) {
    //   addNoScroll();
    // } else {
    //   removeNoScroll();
    // }
  }

  var closeCollectionNav = function (e) {
    $(settings.mobileCollectionNav).removeClass('active')

    // removeNoScroll();
  }

  return { init: init }
})()

var chat = (function () {
  var settings = {
    chatTrigger: "a[href='#live-chat']",
    olarkBtn: '.olark-launch-button',
  }

  var init = function () {
    if ($(settings.chatTrigger).length === 0) return

    $(document).on('click', settings.chatTrigger, clickOlarkBtn)
  }

  var clickOlarkBtn = function (e) {
    e.preventDefault()

    $(settings.olarkBtn).click()
  }

  return { init: init }
})()

var tabs = (function () {
  var init = function () {
    if ($('.table-tabs').length > 0) {
      $('.table-tabs a').on('click', function (e) {
        e.preventDefault()
        $(this).parent().siblings().removeClass('active')
        $(this).parent().siblings().children('a').attr('tabindex', '-1').attr('aria-selected', 'false')

        $(this).parent().addClass('active')
        $(this).attr('tabindex', '0').attr('aria-selected', 'true')

        $($(this).attr('href')).siblings().removeClass('active')
        $($(this).attr('href')).addClass('active')
      })

      $('.table-tabs').on('keydown', function (e) {
        var $target = $(e.target)

        if (e.keyCode === 39) {
          // Right arrow key pressed
          $target.parent().next().children('a').click().focus()
        } else if (e.keyCode === 37) {
          // Left arrow key pressed
          $target.parent().prev().children('a').click().focus()
        }
      })
    }

    if ($('.table-style-C').length > 0) {
      $('.table-style-C').each(function () {
        var labelA = $(this).find('th:nth-child(2)').html(),
          labelB = $(this).find('th:nth-child(3)').html(),
          labelC = $(this).find('th:nth-child(4)').html()

        $(this).find('td:nth-child(2)').attr('data-label', labelA)
        $(this).find('td:nth-child(4)').attr('data-label', labelB)
        $(this).find('td:nth-child(6)').attr('data-label', labelC)
      })
    }

    if ($('a.to-top').length > 0) {
      $('a.to-top').on('click', function () {
        $(this).blur()
      })
    }
  }

  return {
    init: init,
  }
})()

var wishlist = (function () {
  var addAllWishlistItems = () => {
    var items = []

    $('.shappify_add_to_cart_form')
      .not('.soldout')
      .each(function (index, form) {
        let id = $(form).find('[name="id"]').val()

        var item = {
          id: id,
          quantity: 1,
        }

        items.push(item)
      })

    var body = {
      items: items,
    }

    var params = {
      url: '/cart/add.js',
      dataType: 'json',
      data: body,
      method: 'POST',
      success: function (response) {
        cart.onCartUpdate()
      },
    }

    $.ajax(params)
  }

  var init = function () {
    if ($('.js-add-all-wishlist').length) {
      $('.js-add-all-wishlist').on('click', addAllWishlistItems)
    }
  }

  return {
    init: init,
  }
})()

let teamPagination = (function () {
  var settings = {
    teamMembersSection: '#team-members',
    aboutSection: '#shopify-section-about-team-blocks',
  }

  let init = function () {
    if (!$(settings.teamMembersSection).length) return

    $(document).on('click', '#team-members .page a, #team-members .prev a, #team-members .next a', getNextPage)
  }

  let getNextPage = function (e) {
    e.preventDefault()

    let $this = $(this)
    let href = $this.attr('href')

    let url = href + '&sections=about-team-blocks'

    $.ajax(url).then(function (response) {
      if (response && response['about-team-blocks']) {
        $(settings.aboutSection).replaceWith($(response['about-team-blocks']))
        $(settings.aboutSection).find('.will-animate').addClass('animate')
        scrollToTeamSection()
        history.replaceState({}, '', href)
      }
    })
  }

  let scrollToTeamSection = function () {
    $(settings.teamMembersSection)[0].scrollIntoView()
  }

  return {
    init,
  }
})()

// +++++++++++++++++++++
// Initialize all custom JS modules here
// +++++++++++++++++++++
var init = function () {
  navigation.init()
  // cart.init();
  slickSliders.init()
  collection.init()
  mobileNavToggle.init()
  videoSection.init()
  accessibility.init()
  accordion.init()
  productFAQs.init()
  productRecommendations.init()
  customSelect.init()
  CFCustomSelect.init()
  blogSection.init()
  article.init()
  account.init()
  sidebarPage.init()
  animations.init()
  sectionNumbers.init()
  chat.init()
  tabs.init()
  teamPagination.init()
  wishlist.init()
}

$(document).ready(init)

var limitUserFocus = function (container, firstElement, lastElement) {
  $container = $(container)
  $firstElement = $(firstElement)
  $lastElement = $(lastElement)
  $firstElement.focus()
  $container.on('keydown', cycleFocusableElements)
}

var cycleFocusableElements = function (e) {
  if (e.target == $firstElement.get(0) && e.key == 'Tab' && e.shiftKey) {
    e.preventDefault()
    $lastElement.focus()
  } else if (e.target == $lastElement.get(0) && e.key == 'Tab' && !e.shiftKey) {
    e.preventDefault()
    $firstElement.focus()
  }
}

var expandUserFocus = function (focusTarget) {
  $(focusTarget).focus()
  $(window).off()
}

window.onload = function () {
  $('#skip-to-main').focus()

  $(document).on('input', '.js-laptop-width-slider', function () {
    $('.js-laptop-width-slider-value').html(`${$(this).val()}"`)
  })
  $(document).on('input', '.js-laptop-depth-slider', function () {
    $('.js-laptop-depth-slider-value').html(`${$(this).val()}"`)
  })
}
